"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditPrompt = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ModalContext_1 = require("../context/ModalContext");
const useSendPrompt_1 = require("../common/hooks/useSendPrompt");
const textUtil_1 = require("../common/textUtil");
const EditPrompt = () => {
    const context = (0, react_1.useContext)(ModalContext_1.ModalContext);
    const { editCurrent, retryCurrent, stopRequest } = (0, useSendPrompt_1.useSendPrompt)();
    const [editPrompt, setEditPrompt] = (0, react_1.useState)('');
    const submit = () => {
        if (context.loadingResponse) {
            stopRequest();
        }
        else if (editPrompt.trim().length) {
            editCurrent(editPrompt);
            setEditPrompt('');
        }
        else {
            retryCurrent();
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex-grow", children: [(0, jsx_runtime_1.jsx)("label", { children: "Doplnit zad\u00E1n\u00ED" }), (0, jsx_runtime_1.jsx)("input", { name: "data[user_text]", className: "input-sm form-control", value: editPrompt, onKeyUp: (e) => (0, textUtil_1.onKeyboardEnter)(e, () => submit()), onChange: (e) => setEditPrompt(e.target.value) })] }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("button", { className: `btn btn-info ${context.loadingResponse ? ' is-submitting-icon' : ''}`, disabled: false, title: 'Generovat', onClick: submit, children: [(0, jsx_runtime_1.jsx)("i", { className: "bi bi-stars m-r-1" }), context.loadingResponse ? 'Zastavit' : 'Generovat'] }) })] }));
};
exports.EditPrompt = EditPrompt;
